import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconStar"><Path d="M12 1.5L15.0284 7.83938L22 8.75735L16.9 13.5933L18.1803 20.5L12 17.1494L5.81966 20.5L7.1 13.5933L2 8.75735L8.97163 7.83938L12 1.5Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconStar;
